import React from 'react';
import { SINGULAR_EVENTS } from '../constants/singularEventTypes';
import {
  isSingularEventEnabled,
  trackPaywallView,
} from '../utils/singularUtils';

/**
 * Fires a single `paywall_view` Singular event each time a CS-011
 * (no access) occurrence starts, deduped so re-renders while the same
 * occurrence is active don't refire. Resets once `triggered` goes back to
 * false, so the next CS-011 occurrence fires again.
 * @param {boolean} triggered whether a CS-011 paywall is currently shown
 * @param {Record<string, boolean>|undefined} eventsConfig client's useSingular.events
 * @param {Record<string, unknown>} [extra]
 */
export function useSingularPaywallView(triggered, eventsConfig, extra = {}) {
  const alreadyTrackedRef = React.useRef(false);

  React.useEffect(() => {
    if (!triggered) {
      alreadyTrackedRef.current = false;
      return;
    }

    if (alreadyTrackedRef.current) {
      return;
    }

    if (!isSingularEventEnabled(SINGULAR_EVENTS.PAYWALL_VIEW, eventsConfig)) {
      return;
    }

    alreadyTrackedRef.current = true;
    trackPaywallView(extra);
  }, [triggered, eventsConfig]);
}
